// extracted by mini-css-extract-plugin
module.exports = {"type_block":"a10a3f92e9--type_block--38Av6","type":"a10a3f92e9--type--3tfNA","type_block--without_icon":"a10a3f92e9--type_block--without_icon--2ppQZ"};